<template>
    <div>
        <v-app>

            <v-toolbar flat color="white">


                <v-toolbar-title class="congatec-gray">Right administration</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-text-field id="right_search_bar"
                              v-model="search"
                              class="searchbar"
                              append-icon="search"
                              label="Search"
                              single-line
                              hide-details></v-text-field>

                <v-btn id="create_pool_group_right_button" class="text-none" color="success"
                       @click="onCreatePoolRight()" v-if="createRight">Create pool
                    right
                </v-btn>
                <v-btn id="create_app_right_button" class="text-none" color="success" @click="onCreateAppRight()"
                       v-if="createRight">Create app
                    right
                </v-btn>


                <ShowRightModal v-model="showRightModal" :editMode="editMode" :disabled="disabled"
                                :isAppRight="isAppRight" :right="right"/>

            </v-toolbar>


            <v-divider></v-divider>


            <RightList :appRight="false" :deleteRight="deleteRight" :updateRight="updateRight" :search="search"/>

            <v-toolbar flat color="white">

            </v-toolbar>

            <RightList :appRight="true" :deleteRight="deleteRight" :updateRight="updateRight" :search="search"/>

        </v-app>

    </div>
</template>

<script>

    import RightList from './common/rights/RightList.vue'
    import ShowRightModal from './common/rights/modals/ShowRightModal.vue'

    export default {
        name: "Rights",

        components: {
            RightList,
            ShowRightModal
        },

        data: () => ({
            search: "",

            right: {
                rightId: null,
                name: null,
                description: null
            },

            emptyRight: {
                rightId: null,
                name: null,
                description: null
            },

            createRight: false,
            deleteRight: false,
            updateRight: false,

            showRightModal: false,
            disabled: false,
            editMode: false,
            isAppRight: false
        }),

        created() {
            this.initializeRights();
        },

        methods: {
            initializeRights() {
                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "RightCreate") {
                        this.createRight = true;
                    }

                    if (right.right === "RightDelete") {
                        this.deleteRight = true;
                    }

                    if (right.right === "RightUpdate") {
                        this.updateRight = true;
                    }
                });
            },

            onCreateAppRight() {
                this.editMode = false;
                this.isAppRight = true;
                this.disabled = false;
                this.right = Object.assign({}, this.emptyRight);

                this.showRightModal = true;
            },

            onCreatePoolRight() {
                this.editMode = false;
                this.isAppRight = false;
                this.disabled = false;
                this.right = Object.assign({}, this.emptyRight);

                this.showRightModal = true;
            },
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Rights.vue